import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo, useRef } from 'react';
import PaymentForm from './PaymentForm';
import { I18nProvider } from '../i18n/I18nProvider';
function usePaymentForm(_ref) {
  var _dropinProps$bookingD, _dropinRef$current;
  var config = _ref.config,
    paymentOptions = _ref.paymentOptions,
    dropinProps = _ref.dropinProps,
    participants = _ref.participants,
    setAdyenCheckout = _ref.setAdyenCheckout,
    setApp18voucher = _ref.setApp18voucher,
    app18voucher = _ref.app18voucher;
  var dropinRef = useRef();
  var options = _objectSpread({
    hasToPay: paymentOptions.hasToPay,
    currency: paymentOptions.currency,
    amount: paymentOptions.amount,
    country: paymentOptions.country,
    authToken: paymentOptions.authToken,
    paymentAccountId: paymentOptions.paymentAccountId,
    apiHost: config.apiHost,
    participants: participants,
    enableStoreDetails: paymentOptions.storePaymentMethod,
    googlePayConfiguration: paymentOptions.googlePayConfiguration
  }, dropinProps);
  var Payment = useMemo(function () {
    return React.createElement(I18nProvider, {
      lang: dropinProps.lang
    }, React.createElement(PaymentForm, _extends({
      ref: dropinRef,
      config: config,
      setAdyenCheckout: setAdyenCheckout,
      app18voucher: app18voucher,
      setApp18voucher: setApp18voucher
    }, options)));
  }, [(_dropinProps$bookingD = dropinProps.bookingData) === null || _dropinProps$bookingD === void 0 ? void 0 : _dropinProps$bookingD.bookingId]);
  return [Payment, dropinRef === null || dropinRef === void 0 || (_dropinRef$current = dropinRef.current) === null || _dropinRef$current === void 0 ? void 0 : _dropinRef$current.submit];
}
export default usePaymentForm;